import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/testimonials/Testimonials.tsx");
